export const allMinorDefects = [
    { label: "Bitterpit", value: "bitterpit" },
    { label: "Bronzing", value: "bronzing" },
    { label: "Brown Core", value: "brown_core" },
    { label: "Bruises", value: "bruises" },
    { label: "Compression Damage", value: "compression_damage" },
    { label: "Concentric Cracking", value: "concentric_cracking" },
    { label: "Crown damage", value: "crown_damage" },
    { label: "Crumbled berries", value: "crumbled_berries" },
    { label: "Damage", value: "damage" },
    { label: "Darker fruit", value: "darker_fruit" },
    { label: "Deformed", value: "deformed" },
    { label: "Dehydration", value: "dehydration" },
    { label: "Doubles", value: "doubles" },
    { label: "Dry Bruises", value: "dry_bruises" },
    { label: "Dry Calyx", value: "dry_calyx" },
    { label: "Dry Cells", value: "dry_cells" },
    { label: "Dust/Sand", value: "dust_sand" },
    { label: "Floral remains", value: "floral_remains" },
    { label: "Freezing Injury", value: "freezing_injury" },
    { label: "Fruit split in cavity", value: "Fruit_split_in_cavity" },
    { label: "Grub presence", value: "grub_presence" },
    { label: "Hail damage", value: "hail_damage" },
    { label: "Handling Damage", value: "handling_damage" },
    { label: "Harvest Damage", value: "harvest_damage" },
    { label: "Immature", value: "immature" },
    { label: "Insect damage", value: "insect_damage" },
    { label: "Insects", value: "insects" },
    { label: "Injury of the Stalk Cavity", value: "injury_of_the_stalk_cavity" },
    { label: "Internal Browning", value: "internal_browning" },
    { label: "Lenticel", value: "lenticel" },
    { label: "LTD", value: "ltd" },
    { label: "Mechanical damage", value: "mechanical_damage" },
    { label: "Misformed", value: "misformed" },
    { label: "Misshaped", value: "misshaped" },
    { label: "Moderate stem dehydration", value: "moderate_stem_dehydration" },
    { label: "Mold", value: "mold" },
    { label: "Mold on blossom end", value: "mold_on_blossom_end" },
    { label: "Mold on stem end", value: "mold_on_stem_end" },
    { label: "No Calyx", value: "no_calyx" },
    { label: "Open Injuries", value: "open_injuries" },
    { label: "Pitting", value: "pitting" },
    { label: "Pruineless", value: "pruineless" },
    { label: "Pulled stem", value: "pulled_stem" },
    { label: "Punctures", value: "punctures" },
    { label: "Red cells", value: "red_cells" },
    { label: "Residue", value: "residue" },
    { label: "Rot", value: "rot" },
    { label: "Ruseting", value: "ruseting" },
    { label: "Russet", value: "russet" },
    { label: "Russet/Scar", value: "russet_scar" },
    { label: "Russeting", value: "russeting" },
    { label: "Scab", value: "scab" },
    { label: "Scald", value: "scald" },
    { label: "Scarring", value: "scarring" },
    { label: "Scars", value: "scars" },
    { label: "Scars wounds", value: "scars_wounds" },
    { label: "Sensitive", value: "sensitive" },
    { label: "Shrivelling", value: "shrivelling" },
    { label: "Shrivelling (Heavy)", value: "shrivelling_heavy" },
    { label: "Skin Deffects", value: "skin_deffects" },
    { label: "Small bruises", value: "small_bruises" },
    { label: "Sooty Mold", value: "sooty_mold" },
    { label: "Split", value: "split" },
    { label: "Stems", value: "stems" },
    { label: "Sun burn", value: "sun_burn" },
    { label: "Underripe green", value: "underripe_green" },
    { label: "Underripe red", value: "underripe_red" },
    { label: "Undersized", value: "undersized" },
    { label: "Unripe", value: "unripe" },
    { label: "Water Cells", value: "water_cells" },
    { label: "Water Core", value: "water_core" },
    { label: "Wet/Open Berries", value: "wet_open_berries" },
    { label: "Wounds", value: "wounds" }
];

export const allMajorDefects = [
    { label: "Animal Damage", value: "animal_damage" },
    { label: "Botrytis", value: "botrytis" },
    { label: "Bronze Color", value: "bronze_color" },
    { label: "Brown Heart/Cavities", value: "brown_heart_cavities" },
    { label: "Chilling Injury", value: "chilling_injury" },
    { label: "Core Breakdowns", value: "core_breakdowns" },
    { label: "Cracking", value: "cracking" },
    { label: "Cracked Fresh", value: "cracked_fresh" },
    { label: "Cracks", value: "cracks" },
    { label: "Crown mold", value: "crown_mold" },
    { label: "Crushed", value: "crushed" },
    { label: "Cuts", value: "cuts" },
    { label: "Decay", value: "decay" },
    { label: "Discolored", value: "discolored" },
    { label: "Dry Crack", value: "dry_crack" },
    { label: "Freezing damage", value: "freezing_damage" },
    { label: "Fresh Crack", value: "fresh_crack" },
    { label: "Grittiness", value: "grittiness" },
    { label: "Heavy bruises", value: "heavy_bruises" },
    { label: "Inconsistent brunch", value: "inconsistent_brunch" },
    { label: "Insect", value: "insect" },
    { label: "Injury of the Stalk Cavity", value: "injury_of_the_stalk_cavity" },
    { label: "Internal Breakdown", value: "internal_breakdown" },
    { label: "Juicing", value: "juicing" },
    { label: "Juicing/Exudated berry", value: "juicing_exudated_berry" },
    { label: "Leaking", value: "leaking" },
    { label: "Mold", value: "mold" },
    { label: "Mold Hotspot", value: "mold_hotspot" },
    { label: "Moldy Crown", value: "moldy_crown" },
    { label: "Overripe", value: "overripe" },
    { label: "Pulled stems", value: "pulled_stems" },
    { label: "Rot", value: "rot" },
    { label: "Rot hotspot", value: "rot_hotspot" },
    { label: "Rot under the crown", value: "rot_under_the_crown" },
    { label: "Rotting", value: "rotting" },
    { label: "Severe Bronze Color", value: "severe_bronze_color" },
    { label: "Severe Bruising", value: "severe_bruising" },
    { label: "Severe Hail Damage", value: "severe_hail_damage" },
    { label: "Severe Mechanical Damage", value: "severe_mechanical_damage" },
    { label: "Severe Russeting", value: "severe_russeting" },
    { label: "Severe Scab", value: "severe_scab" },
    { label: "Severe stem dehydration", value: "severe_stem_dehydration" },
    { label: "Shriveling", value: "shriveling" },
    { label: "Soft", value: "soft" },
    { label: "Split", value: "split" },
    { label: "Stem brownish", value: "stem_brownish" },
    { label: "Too Ripe", value: "ripe" },
    { label: "Wet bruises", value: "wet_bruises" },
    { label: "Wet fruit", value: "wet_fruit" },
    { label: "Wet punnet", value: "wet_punnet" },
    { label: "White cells", value: "white_cells" },
    { label: "Wounds", value: "wounds" },
    { label: "Yellow rust", value: "yellow_rust" }
];